import React, { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { optionsState } from '../options';
import { customPreview as Symbol_customPreview } from '../symbols';
import { isMap, isSet } from '../utils/types';
import { ExpandIcon } from './ExpandIcon';
import { Name } from './Name';
import { Value } from './Value';
import { Preview } from './Preview';
import { Tree } from './Tree';

function setCustomPreviews(_ref) {
  let {
    hideDataTypes,
    hideObjectSize,
    previewElementsMaxCount,
    previewPropertiesMaxCount,
    previewStringMaxLength
  } = _ref;
  return value => {
    if (isSet(value)) {
      return [...value].reduce((acc, v, i) => {
        acc[i] = {
          value: v,

          [Symbol_customPreview]() {
            return /*#__PURE__*/React.createElement(Value, {
              data: v
            });
          }

        };
        return acc;
      }, {});
    } else if (isMap(value)) {
      return [...value].reduce((acc, _ref2, i) => {
        let [k, v] = _ref2;
        acc[i] = {
          key: k,
          value: v,

          [Symbol_customPreview]() {
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Name, {
              data: `'${k}'`
            }), /*#__PURE__*/React.createElement("span", null, "\xA0=>\xA0"), /*#__PURE__*/React.createElement(Value, {
              data: v
            }));
          }

        };
        return acc;
      }, {});
    }

    return value;
  };
}

export function Node(_ref3) {
  let {
    data: [key, value],
    depth
  } = _ref3;
  const options = useRecoilValue(optionsState);
  const {
    expandLevel,
    hidePreviews
  } = options;
  const [isExpanded, toggle] = useState(depth < expandLevel);
  useEffect(() => {
    toggle(depth < expandLevel);
  }, [depth, expandLevel]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex'
    },
    onClick: e => {
      e.stopPropagation();
      toggle(!isExpanded);
    }
  }, /*#__PURE__*/React.createElement(ExpandIcon, {
    isExpanded: isExpanded
  }), /*#__PURE__*/React.createElement(Name, {
    data: key,
    style: {
      cursor: 'pointer',
      flex: 'none',
      userSelect: 'none'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none'
    }
  }, ":\xA0"), !hidePreviews && /*#__PURE__*/React.createElement(Preview, {
    data: value,
    hide: isExpanded,
    hidePlaceholder: isMap(value) || isSet(value) ? /*#__PURE__*/React.createElement("i", {
      style: {
        opacity: 0.3
      }
    }, "[[Entries]]") : null
  })), isExpanded ? /*#__PURE__*/React.createElement(Tree, {
    data: setCustomPreviews(options)(value),
    depth: depth + 1
  }) : null);
}